<div class="relative z-10">
  <div
    class="group mb-5 flex h-[70px] items-center justify-between rounded-lg bg-base-glacier-50 pr-3 [box-shadow:0px_2px_4px_0px_rgba(0,_0,_0,_0.15)] hover:bg-base-glacier-100"
  >
    <div class="flex items-center justify-start">
      <div class="ml-2 flex h-14 w-14 items-center justify-center rounded-lg bg-gray-300">
        <img
          app-img
          class="h-12 w-12 select-none rounded-lg"
          [src]="subdivision.thumbnail"
          onerror="src='assets/images/default.png'"
        />
      </div>
      <p class="md:text-[14px]font-medium pl-4 text-center text-[11px]">
        <span class="px-2 text-md md:whitespace-nowrap">{{ subdivision.nome }}</span>
        <i *ngIf="subdivision.fixar" class="fa fa-map-pin"></i>
      </p>
    </div>
    <div class="flex items-center justify-between">
      <div class="flex items-center justify-between gap-5">
        <div class="opacity-0 group-hover:opacity-100">
          <button
            (click)="onOpenPopover(popoverLeft, [strategy.LEFT])"
            #popoverLeft
            app-outline-button
            type="button"
            app-button
            class="group/dots"
          >
            <svg-icon
              class="w-2 text-base-status-info-600 group-hover/dots:text-base-status-info"
              src="assets/icons/icon-three-dots.svg"
            ></svg-icon>
          </button>
        </div>
      </div>
      <div class="flex items-center justify-between gap-2">
        <button
          (click)="setOrder(1)"
          *ngIf="!first"
          app-tooltip
          type="button"
          [tooltip]="'trilhas.estudio.curso.move-up' | translate"
          app-button
          class="group/up"
        >
          <svg-icon
            class="w-4 cursor-pointer text-theme-500 opacity-0 group-hover/up:text-base-status-info-800 group-hover:opacity-100 md:w-6"
            src="assets/icons/icon-arrow-move.svg"
          ></svg-icon>
        </button>
        <button
          (click)="setOrder(2)"
          *ngIf="!last"
          app-tooltip
          type="button"
          [tooltip]="'trilhas.estudio.curso.move-down' | translate"
          app-button
          class="group/down"
        >
          <svg-icon
            class="w-4 rotate-180 cursor-pointer text-theme-500 opacity-0 group-hover/down:text-base-status-info-800 group-hover:opacity-100 md:w-6"
            src="assets/icons/icon-arrow-move.svg"
          ></svg-icon>
        </button>
      </div>
    </div>
  </div>
  <div
    *ngIf="subdivision.subdivisao_id === 0"
    class="absolute -left-1 top-0 -z-10 h-[70px] w-4 rounded-l-lg border-theme-500 bg-theme-500"
  ></div>
  <div
    *ngIf="subdivision.subdivisao_id !== 0"
    class="absolute -left-6 bottom-[35px] -z-10 h-[48px] w-7 border-b border-l border-dashed border-theme-500"
  ></div>
  <div
    *ngIf="subdivision.subdivisao_id !== 0 && !last"
    class="absolute -left-6 bottom-[-15px] -z-10 h-[48px] w-7 border-l border-dashed border-theme-500"
  ></div>
</div>
<div *ngIf="hasItems" class="gap-4 pl-10">
  <ng-container *ngFor="let item of subdivision.items; let last = last; let first = first">
    <app-tree-subdivision
      class="gap-4"
      *ngIf="isSubdivision(item)"
      [subdivision]="item"
      [first]="first"
      [last]="last"
      [course_slug]="course_slug"
      [items]="items"
    ></app-tree-subdivision>
    <app-tree-trail
      class="gap-4"
      *ngIf="isTrail(item)"
      [trail]="item"
      [course_slug]="course_slug"
      [first]="first"
      [last]="last"
    ></app-tree-trail>
  </ng-container>
</div>
